// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__aRDnb","zoomWrapper":"Heading_zoomWrapper__TloIS","title":"Heading_title__OYSDQ","text-shadow-drop-center":"Heading_text-shadow-drop-center__MYy9P"};